import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import theme from 'src/theme';
import MissingTasksIcon from './MissingTasksIcon';
import useAppFeature from '../../../app/useAppFeature';
import { AppFeatureEnum } from '../../../enums/appFeatureEnum';
import { useVesselStore } from '../../../context/VesselContext';

type Props = {
    path: string;
    title: string;
    disabled?: boolean;
    bottomMenu?: boolean;
    iconName: IconProp;
    ignoreQueryParams?: boolean;
};

const Wrapper = styled.div`
    position: relative;
    cursor: pointer;
    padding: 10px 3px;
    border-bottom: 1px solid #ddd;
    color: ${theme.legacyColors.darkBlue};

    &:hover {
        background: #eee;
    }

    &.active-link {
        background: ${theme.legacyColors.selectedBackground};
        color: ${theme.legacyColors.selectedColor};
        border-bottom: 1px solid ${theme.legacyColors.selectedBorder};
    }

    &.bottom-menu {
        border-top: 1px solid #ddd;
        border-bottom: none;
    }
`;

const Icon = styled.span`
    text-align: center;
    display: block;
    margin: 0 0 5px 0;
    font-size: 1rem;
`;

const Label = styled.span`
    text-align: center;
    display: block;
    font-size: 0.6rem;
`;

const NavItem: React.FC<Props> = (props) => {
    const location = useLocation();
    const { selectedVessel } = useVesselStore();
    const query = new URLSearchParams(window.location.search);
    const { isFeatureEnabled } = useAppFeature();

    const getPath = (query: URLSearchParams, path: string) => {
        return path;
    };

    const getClass = () => {
        let classString = '';
        if (location.pathname === `/${props.path}`) {
            classString += 'active-link';
        }

        if (props.bottomMenu) {
            classString += ' bottom-menu';
        }

        return classString;
    };

    return (
        <Wrapper className={getClass()}>
            {props.disabled && (
                <>
                    <Icon>
                        <FontAwesomeIcon icon={props.iconName} />
                    </Icon>
                    <Label>{props.title}</Label>
                </>
            )}
            {!props.disabled && (
                <Link
                    to={{
                        pathname: `${getPath(query, props.path)}`,
                        search: !props.ignoreQueryParams ? `${query}` : null,
                    }}
                >
                    <Icon>
                        <FontAwesomeIcon icon={props.iconName} />
                    </Icon>
                    <Label>{props.title}</Label>
                </Link>
            )}

            {selectedVessel && isFeatureEnabled({ featureEnum: AppFeatureEnum.Notifications, date: new Date() }) && (
                <MissingTasksIcon path={props.path}></MissingTasksIcon>
            )}
        </Wrapper>
    );
};

export default NavItem;
